import CreditCardList from 'components/HappeningNonContent/ServiceBooking/ReviewAndPay/PaymentInfo/CreditCardList/CreditCardList';

export default CreditCardList;
